import Loader from "../../components/Loader";
import ErrorBoundary from "../../components/ErrorBoundary";
import classNames from "classnames";
import styles from "./widget.module.css";

const Widget = ({
  children,
  header,
  isLoading,
  lastWidget = false,
  centered = false,
}) => {
  return (
    <ErrorBoundary fallback="Error in widget">
      <div
        className={classNames(styles.widget, {
          [styles.lastWidget]: lastWidget,
          [styles.centered]: centered || isLoading,
        })}
      >
        {isLoading ? (
          <Loader small />
        ) : (
          <>
            {!!header ? (
              <h4 style={{ marginBottom: "var(--padding-aside-v)" }}>
                {header}
              </h4>
            ) : null}
            {children}
          </>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default Widget;
